import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";

import SignUpSuccess from "app/NativeComponents/components/SignUpSuccess";
import RedirectToApp from "app/NativeComponents/components/RedirectToApp";
import SharableProperty from "app/DealMachineCore/components/SharableProperty";

/* app routes */
import ForgotPasswordContainer from "app/NativeComponents/components/ForgotPasswordContainer";
import ResetPassword from "app/NativeComponents/components/ResetPassword";
import App from "./App";
import Logout from "app/DealMachineCore/components/Logout";

import StreetViewiFrame from "app/NativeComponents/components/NativeStreetView/StreetViewiFrame";
import MobileRedirect from "./MobileRedirect";
import PromoRedirect from "./PromoRedirect";
import ChurnKeyPrompt from "app/DealMachineCore/MarketingOnboardingAndFunnel/components/ChurnKeyPrompt";
import NewDealMachineGuide from "app/NativeComponents/components/NewDealMachineGuide";
class RouteBody extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const token = window.localStorage.getItem("token");
    this.props.initApp(true);
  }

  componentWillUnmount() {}

  componentDidUpdate(prevProps) {
    if (this.props.location.href !== prevProps.location.href) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <Switch>
        {/* app routes */}
        <Route path="/sign-up-complete" component={SignUpSuccess} />
        <Route
          path="/sign-up"
          render={({ location }) =>
            //legacy signup is disabled, but members invited to an existing
            //legacy team still accept their invite through this route
            location.search.includes("link_type=team_invite") ? (
              <App />
            ) : (
              <Redirect to="/" />
            )
          }
        />
        <Route path="/churnkey" component={ChurnKeyPrompt} />
        <Redirect from="/offers" to="/" />
        <Redirect from="/payment" to="/" />

        <Route
          exact
          path="/forgot-password"
          component={ForgotPasswordContainer}
        />
        <Route exact path="/reset-password" component={ResetPassword} />
        <Route
          exact
          path="/new-dealmachine-guide"
          component={NewDealMachineGuide}
        />
        <Route path={"/logout"} component={Logout} />

        {/* dealfinder page */}
        <Redirect from="/team" to="/" />
        {/*street view mobile iframe*/}
        <Route exact path={"/virtual-driving"} component={StreetViewiFrame} />

        {/*virtual drive presentation*/}
        <Redirect from="/live-event" to="/" />
        <Redirect from="/list-builder-demo" to="/" />
        <Redirect from="/property-lookup" to="/" />

        {/*shared link redirects */}
        <Route exact path="/task/:id" component={MobileRedirect} />
        <Route exact path="/property/:id" component={MobileRedirect} />
        <Route exact path="/edit-list/:id" component={MobileRedirect} />
        <Route exact path="/notifications" component={MobileRedirect} />

        {/*promo redirect system */}
        <Route exact path="/r/:redirect_slug" component={PromoRedirect} />

        {/* sharable property */}
        <Route exact path="/p/:property_id" component={SharableProperty} />

        {/* app routes */}
        <Route path="/" component={App} />
      </Switch>
    );
  }
}

export default withRouter(connect(null, {})(RouteBody));
